import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { MESSAGE_TYPES } from '../constants';

export function useGroupParticipant(sender, messageType) {
  const currentConversation = useMapGetter('getSelectedChat');

  const isGroupConversation = computed(() => {
    const contact = currentConversation.value?.meta?.sender;
    return contact?.additional_attributes?.is_group === true;
  });

  const shouldShowSenderName = computed(() => {
    return (
      isGroupConversation.value &&
      sender.value &&
      messageType.value === MESSAGE_TYPES.INCOMING
    );
  });

  const senderName = computed(() => {
    return sender.value?.name || '';
  });

  return {
    isGroupConversation,
    shouldShowSenderName,
    senderName,
  };
}
